module.exports = __webpack_public_path__ + "static/ntt-94f5cba67a0c049936f4ec2dcefa94b7.png";